
<flo-view-as-widget
  #viewAsWidget
></flo-view-as-widget>

<!-- Prominent banner when viewing as another user -->
<div *ngIf="isViewingAsUser | async" class="view-as-banner" [ngClass]="{'collapsed': isCollapsed}">
  <div class="view-as-banner-content">
    <span class="view-as-title">
      <strong>⚠️ ADMIN VIEW-AS MODE</strong>
    </span>
    <span class="view-as-details" *ngIf="viewedUserInfo | async as userInfo">
      Viewing as:
      <strong>{{ userInfo.name || userInfo.email }}</strong>
      <span *ngIf="userInfo.name" class="text-muted">({{ userInfo.email }})</span>
      <span class="text-muted">ID: {{ userInfo.id }}</span>
    </span>
    <button class="btn btn-sm btn-light" (click)="viewAsWidget.openModal()">
      Exit View-As Mode
    </button>
  </div>

  <!-- Collapse button - positioned at bottom of banner -->
  <button class="collapse-button" (click)="toggleCollapsed()" [title]="isCollapsed ? 'Show admin view-as banner' : 'Hide admin view-as banner'">
    <flo-svg-icon icon="icon-chevron-down" width="1em" [ngClass]="{'rotate-svg-180': !isCollapsed}"></flo-svg-icon>
  </button>
</div>

<div *ngIf="(debug.debugOn$ | async) || (isViewingAsUser | async)" class="debug-menu p-2">
  <flo-experimentation-widget #expWidget></flo-experimentation-widget>
  <flo-select-input
    [options]="selectMenuItems$ | async"
    [initial]="vs.siteCode$ | async"
    (selected$)="changeVertical($event)"
  ></flo-select-input>
  <button
    *ngIf="canViewAsUser$ | async"
    [class]="(isViewingAsUser | async) ? 'btn btn-danger w-100 mt-1' : 'btn btn-primary primary-color-bg w-100 mt-1'"
    (click)="viewAsWidget.openModal()"
  >
    {{ (isViewingAsUser | async) ? 'Exit View-As' : 'View As User' }}
  </button>
  <button
    class="btn btn-primary primary-color-bg w-100 mt-1"
    (click)="expWidget.toggleWindow()"
    >Experiments</button
  >
</div>
